module.exports = __webpack_public_path__ + "img/178.5e74dd70.png";